<script>
import termsOfService from '@/assets/terms-of-service'

export default {
  name: 'OnboardingProfileTOS',
  props: {
    user: { type: Object, required: true },
    submitting: { type: Boolean, default: () => false }
  },
  data() {
    return {
      termsOfService,
      form: {
        agreements: {
          sellerTos: false
        }
      }
    }
  },
  created() {
    // Event tracking
    const { once } = this.lodash
    const { logEvent } = this.$amplitude

    this.tosAgreed = once(() => {
      logEvent('Seller Onboarding: TOS Agreed')
    })

    // Prefill form
    const { sellerTos } = this.user.agreements || {}
    this.form = {
      agreements: {
        sellerTos: !!sellerTos
      }
    }
  },
  methods: {
    submit() {
      if (!this.form.agreements.sellerTos) return

      const { agreements } = this.form
      this.$emit('submit', { agreements })
    }
  }
}
</script>

<template>
  <div class="view-grid">
    <!-- Onboarding Profile // Terms of Service -->
    <div class="onboarding-profile-tos">
      <!-- Title -->
      <div class="display-1 font-weight-bold accent--text">
        Understand our terms of service
      </div>

      <!-- Terms of Service Text -->
      <v-card
        outlined
        color="transparent"
        class="pa-3 caption flat my-5 overflow-y-auto terms-of-service"
        max-width="100%"
        max-height="240"
        v-html="termsOfService"
      />

      <div>
        <!-- Terms of Service (Required) -->
        <v-checkbox
          v-model="form.agreements.sellerTos"
          color="primary"
          @change="tosAgreed"
        >
          <template v-slot:label>
            <span class="body-2">
              I agree with the Terms of Service (Required)
            </span>
          </template>
        </v-checkbox>
      </div>

      <!-- Action Buttons -->
      <div class="mb-5">
        <v-btn
          :loading="submitting"
          :disabled="!form.agreements.sellerTos"
          rounded
          depressed
          color="primary"
          @click="submit"
        >
          Create my profile
        </v-btn>
      </div>
    </div>
  </div>
</template>

<style lang="sass">
.terms-of-service
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.12) !important
</style>
